import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@src/design-system/dropdown-menu';
import { ArrowDown2 } from 'iconsax-react';
import {
  OPERATOR_LABEL_MAPPER,
  OPERATORS_ACC_TO_FILTER_TYPE,
} from '../../entities-filters/config';
import { cn } from '@src/design-system/helpers';
import { inputVariants } from '@src/design-system/input';

import type { TField } from '@shared/types/field';
import type { TDynamicFilter } from '@shared/types/dynamic-filter';
import dynamicFilterApi from '@shared/features/views/services/dynamic-filter-api';

const getOperatorLabel = (
  operatorValue: keyof typeof OPERATOR_LABEL_MAPPER
) => {
  return OPERATOR_LABEL_MAPPER[operatorValue];
};

export const DynamicOperatorDropdown = ({
  dynamicField,
  questionType,
  currentOperator,
  onChange,
}: {
  dynamicField: TDynamicFilter;
  currentOperator: TDynamicFilter['operator'];
  onChange?: (op: TDynamicFilter['operator']) => void;
  questionType: TField['type'];
}) => {
  const { mutate: editDynamicFilter } = dynamicFilterApi.useUpdate();

  const operatorLabel = getOperatorLabel(currentOperator!);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className={cn(
          'w-full text-sm relative cursor-pointer items-center max-w-[150px]',
          inputVariants({ size: 'sm' })
        )}
      >
        <span className='w-[85%] text-start truncate'>{operatorLabel}</span>
        <ArrowDown2
          size={16}
          className='text-primary-1000 absolute right-2 top-1/2 -translate-y-1/2'
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent align='start'>
        {OPERATORS_ACC_TO_FILTER_TYPE[questionType].map((op) => {
          const operatorLabel = getOperatorLabel(op);
          return (
            <DropdownMenuItem
              key={op}
              onClick={() => {
                if (dynamicField?.id) {
                  editDynamicFilter?.({
                    id: dynamicField?.id,
                    type: dynamicField.field?.type,
                    field: dynamicField.field?.id,
                    operator: op,
                  });
                }

                onChange?.(op);
              }}
            >
              {operatorLabel}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
